import { inject, provide, ref, Ref } from '@vue/composition-api'
import { UserInfoState } from '@/layout/types'

export const userInfoSymbol = Symbol('userInfoState')

export const provideUserInfoState = (userInfoState: Ref<UserInfoState>) => {
  provide<Ref<UserInfoState>>(userInfoSymbol, userInfoState)
}

export const useUserInfoState = () => {
  return inject<Ref<Partial<UserInfoState>>>(userInfoSymbol, ref({}))
}
